import { useCampaignCode } from '@campaign-services/hooks/useCampaignCode'
import { createWithUpdateCosignToken, refreshCosignToken } from '@hooks-api/fortune/refreshCosignToken'
import { getClient } from '../../../clients'

const withUpdateCosignToken = createWithUpdateCosignToken([getClient('cosign'), getClient('eCommerce'), getClient('eCommerceV2'), getClient('fortune')])

export const RefreshCosignToken = () => {
  const { campaignCodeFromUrl } = useCampaignCode()
  refreshCosignToken({ code: campaignCodeFromUrl }, { use: [withUpdateCosignToken] })
  return null
}
